import exchangeApi from '../../api/exchange-api';
const EXCHANGE_SET_CURRENCIES = 'exchangeSetCurrencies';
const EXCHANGE_CALCULATION_REQUEST = 'exchangeCalculationRequest';
const EXCHANGE_CALCULATION_SUCCESS = 'exchangeCalculationSuccess';
const EXCHANGE_TECHNICAL_FAILURE = 'exchangeTechnicalFailure';
const EXCHANGE_RESET_RESULTS = 'exchangeResetResults';

const exchangeState = {
	loading: false,
	technicalError: false,
	currencies: [],
	results: null
};

const exchangeActions = {
	getCurrencies({ commit }) {
		exchangeApi
			.getCurrencies()
			.then((response) => {
				commit(EXCHANGE_SET_CURRENCIES, response.data);
			})
			.catch(() => {
				commit(EXCHANGE_TECHNICAL_FAILURE);
			});
	},
	calculate({ commit }, model) {
		commit(EXCHANGE_CALCULATION_REQUEST);
		exchangeApi
			.exchangeCalculation(model)
			.then((response) => {
				commit(EXCHANGE_CALCULATION_SUCCESS, response.data);
			})
			.catch(() => {
				commit(EXCHANGE_TECHNICAL_FAILURE);
			});
	},
	resetResults({ commit }) {
		commit(EXCHANGE_RESET_RESULTS);
	}
};

const exchangeMutations = {
	[EXCHANGE_SET_CURRENCIES](state, currencies) {
		state.currencies = currencies;
	},
	[EXCHANGE_TECHNICAL_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[EXCHANGE_CALCULATION_SUCCESS](state, results) {
		state.results = results;
		state.loading = false;
	},
	[EXCHANGE_CALCULATION_REQUEST](state) {
		state.loading = true;
	},
	[EXCHANGE_RESET_RESULTS](state) {
		state.results = null;
	}
};

export default {
	namespaced: true,
	state: exchangeState,
	mutations: exchangeMutations,
	actions: exchangeActions
};
